import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import imageCompression from 'browser-image-compression';

function StorageFactory(firebase) {
  const uploadQuestionImage = async (file, sessionId) => {
    try {
      // Compression options
      const compressionOptions = {
        maxWidthOrHeight: 1101,
        initialQuality: 0.8,
        useWebWorker: true
      };

      // Compress and resize image
      const compressedFile = await imageCompression(file, compressionOptions);

      // Log compression results
      const originalSizeMB = (file.size / 1024 / 1024).toFixed(2);
      const compressedSizeMB = (compressedFile.size / 1024 / 1024).toFixed(2);
      console.log(
        `Image compressed: ${originalSizeMB}MB → ${compressedSizeMB}MB (${((1 - compressedFile.size / file.size) * 100).toFixed(1)}% reduction)`
      );

      // Generate unique filename with timestamp
      const timestamp = Date.now();
      const filename = `${timestamp}_${file.name}`;
      const storagePath = `question-images/${sessionId}/${filename}`;

      // Create storage reference using the dedicated question images bucket
      const storageRef = ref(firebase.questionImagesStorage, storagePath);

      // Upload compressed file with metadata
      const metadata = {
        contentType: compressedFile.type,
        customMetadata: {
          uploadedAt: new Date().toISOString(),
          sessionId,
          originalSize: String(file.size),
          compressedSize: String(compressedFile.size)
        }
      };

      await uploadBytes(storageRef, compressedFile, metadata);

      // Get download URL
      const downloadURL = await getDownloadURL(storageRef);

      return downloadURL;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  };

  return {
    uploadQuestionImage
  };
}

export default StorageFactory;
